import { CARE_PILLARS } from '../constants';

function CareSection() {
  const n = CARE_PILLARS.length;
  const cols =
    n === 1 ? 'lg:grid-cols-1'
    : n === 2 ? 'lg:grid-cols-2'
    : n >= 4 ? 'lg:grid-cols-4'
    : 'lg:grid-cols-3';
  return (
    <section id="care" className="border-y border-line/60 bg-plum">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-black uppercase tracking-[0.22em] text-sage">
            Design principles
          </p>
          <h2 className="font-display mt-3 text-4xl tracking-tight text-ink sm:text-5xl">
            Intelligence that feels more human.
          </h2>
          <p className="mt-5 leading-8 text-muted">
            A focused look at the ideas guiding a more thoughtful, relational future for AI.
          </p>
        </div>

        <div className={`mt-14 grid gap-5 md:grid-cols-2 ${cols}`}>
          {CARE_PILLARS.map((pillar) => (
            <article
              key={pillar.title}
              className="group flex h-full flex-col rounded-3xl border border-line bg-surface/80 p-7 transition hover:-translate-y-1 hover:border-sage/60 hover:shadow-soft"
            >
              <span
                aria-hidden
                className="font-display grid h-12 w-12 place-items-center rounded-xl border border-sage/30 bg-sage/10 text-2xl text-sage transition group-hover:bg-sage group-hover:text-plum"
              >
                {pillar.icon}
              </span>
              <h3 className="font-display mt-6 text-2xl text-ink">{pillar.title}</h3>
              <p className="mt-3 leading-7 text-muted">{pillar.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareSection;
